// VIDEO CONFIG //
//Bightcove account ID
export const PLL_VIDEO_ACCOUNT_ID = process.env.REACT_APP_VIDEO_ACCOUNT_ID
//Brightcove player ID
export const DEFAULT_VIDEO_PLAYER_ID = 'FajRXawD0'
//Brightcove player scripts
export const VIDEO_PLAYER_SCRIPT = `//players.brightcove.net/${PLL_VIDEO_ACCOUNT_ID}/${DEFAULT_VIDEO_PLAYER_ID}_default/index.min.js`
export const VIDEO_PLAYER_SCRIPT_ID = `bc-player-${PLL_VIDEO_ACCOUNT_ID}-${DEFAULT_VIDEO_PLAYER_ID}`
